import styled from 'styled-components'
import palette from 'theme/palette'

export const Container = styled.div`
  background: transparent !important;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  transition: 0.5s ease-in-out;
  position: fixed;
  right: 0;
  margin-top: -11px;

  .sidebar-collapse-button {
    position: absolute;
    background-color: #eeeeee;
    padding: 10px;
    box-shadow: -3px 0px 10px rgba(0, 0, 0, 0.1);
    border: 1px solid #dddddd;
    border-right: none;
    border-radius: 8px 0px 0px 8px;
    margin-top: 40px;
    color: ${palette.primary.main};
    font-size: 10px;
    margin-left: -41px;
    cursor: pointer;
  }
`

export const SideBarContainer = styled.div`
  width: 300px;
  padding: 30px;
  background-color: #fafafa;
  font-family: 'Roboto', sans-serif;
  letter-spacing: 0.5px;
  height: calc(100vh - 130px);
  overflow-y: scroll;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.15);
  transition: 0.5s ease-in-out;

  -ms-overflow-style: none;
  scrollbar-width: 4px;
  scrollbar-color: #b5b5b5;

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: #b5b5b5;
    border-radius: 50px;
  }
`
